<template>
  <div>
    <md-field :class="nameValidationClass">
      <label>Name</label>
      <md-input v-model="shareCartModel.name" required></md-input>
      <span class="md-error">Name is required</span>
    </md-field>
    <md-field>
      <label>Message</label>
      <md-input v-model="shareCartModel.message"></md-input>
    </md-field>
    <div>
      <md-datepicker
        v-model="shareCartModel.expirationDate"
        md-immediately
        :class="expirationDateValidationClass"
      >
        <label>Expiration date</label>
        <span class="md-error">Expiration date is required</span>
      </md-datepicker>
    </div>
    <div style="display: flex">
      <md-checkbox v-model="shareCartModel.notifyUsers" v-if="!isEditMode">
        Notify users by email
      </md-checkbox>
      <md-checkbox
        v-model="shareCartModel.notifyUsers"
        v-if="isEditMode && newUsersAdded"
      >
        Notify new users by email
      </md-checkbox>
    </div>
    <div>
      <md-autocomplete
        v-model="selectedUser"
        :md-options="users"
        @md-changed="getUsers"
        @md-opened="getUsers"
        @md-selected="userSelected"
      >
        <label>Users</label>
        <template slot="md-autocomplete-item" slot-scope="{ item }">{{
            item
          }}</template>
      </md-autocomplete>
      <div
        style="display: flex; align-items: center"
        v-for="(user, index) in shareCartModel.sharedWithUsers"
        :key="index"
      >
        <span>{{ user }}</span>
        <md-button
          class="md-simple md-just-icon md-round auto-height"
          @click="removeUserSelected(user)"
        >
          <md-icon>clear</md-icon>
        </md-button>
      </div>
    </div>
  </div>
</template>
<script>
import Api from "@/services/Api";
export default {
  name: "shared-cart-details",
  props: {
    shareCartModel: {
      type: Object,
      default: {
        id: "",
        name: "",
        message: "",
        expirationDate: new Date().toISOString().slice(0, 10),
        notifyUsers: false,
        sharedWithUsers: [],
        environmentId: ""
      },
    },
    isEditMode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedUser: null,
      users: [],
      oldUsersIds: [],
    };
  },
  computed: {
    nameValidationClass() {
      return {
        "md-invalid": !this.shareCartModel.name,
      };
    },
    expirationDateValidationClass() {
      return {
        "md-invalid": !this.shareCartModel.expirationDate,
      };
    },
    newUsersAdded() {
      let difference = this.shareCartModel.sharedWithUsers.filter(
        (x) => !this.oldUsersIds.includes(x)
      );
      return difference.length > 0;
    },
  },
  mounted() {
    this.oldUsersIds = this.shareCartModel.sharedWithUsers.map((el) => el);
  },
  methods: {
    getUsers(searchTerm) {
      if (searchTerm) {
        this.users = new Promise((resolve) => {
          Api()
            .get("/search/users/?searchTerm=" + searchTerm)
            .then((response) => resolve(response.data.result));
        });
      }
    },
    userSelected(user) {
      this.selectedUser = "";
      this.shareCartModel.sharedWithUsers.push(user);
    },
    removeUserSelected(user) {
      let users = this.shareCartModel.sharedWithUsers;
      users.splice(
        users.findIndex((el) => el === user),
        1
      );
    },
  },
};
</script>
<style>
.md-menu-content {
  z-index: 9999 !important;
}
.md-datepicker-dialog {
  z-index: 9999 !important;
}
.md-tooltip {
  z-index: 9999 !important;
  white-space: normal !important;
}
.disabled {
  pointer-events: none;
  opacity: 0.6;
}
.md-checkbox-label {
  font-size: 14px;
}
.md-datepicker-dialog .md-datepicker-header {
  background: var(--pz-primary-color) !important;
}
.md-datepicker-today,
.md-datepicker-today:hover,
.md-datepicker-selected,
.md-datepicker-selected:hover {
  background-color: var(--pz-primary-color) !important;
}
.md-button.md-primary,
.md-button.md-primary:hover {
  background-color: var(--pz-primary-color) !important;
}
</style>
